import { type FC, useRef, useState } from 'react';

import { useClickAway } from '@crehana/react-hooks';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Chip } from '@crehana/ui';

import { ChipTag, Popper } from './ChipAttributes.styles';
import type { Attribute, ChipAttributesProps } from './types';

const ChipAttributes: FC<React.PropsWithChildren<ChipAttributesProps>> = ({
  attributes,
  isDark,
}) => {
  const [showPopper, setShowPopper] = useState(false);
  const popperRef = useRef<HTMLDivElement>(null);

  useClickAway(popperRef, () => setShowPopper(false));

  const attributesSelected: Attribute[] = [];

  attributes.filter(attribute => {
    Object.keys(attribute).map(idx => {
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (attribute[idx]) attributesSelected.push(attribute[idx]);
    });
  });

  return (
    <>
      {attributesSelected.map((attribute, idx) => {
        if (idx === 0) {
          return (
            <ChipTag
              // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
              key={`${attribute}-${idx}`}
              className="font-body4"
              label={attribute.label}
            />
          );
        }
        if (idx === 1) {
          return (
            // TODO: talk with the code owner to fix this code so we can enable this rule again
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div
              ref={popperRef}
              className="relative"
              // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
              key={`${attribute}-${idx}`}
              onClick={() => setShowPopper(!showPopper)}
            >
              <Chip
                className="font-body4 whitespace-no-wrap ml-4"
                label={`+ ${attributesSelected.length - 1}`}
              />
              {showPopper && (
                <Popper
                  className="w-200 shadow-tooltip z-dialog text-base-main"
                  isDark={isDark}
                >
                  {attributesSelected.map((attr, x) => (
                    <ChipTag
                      // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
                      key={`${attr.label}-${x}`}
                      className="font-body4"
                      label={attr.label}
                    />
                  ))}
                </Popper>
              )}
            </div>
          );
        }
      })}
    </>
  );
};

export default ChipAttributes;
